module.exports = __webpack_public_path__ + "static/past-8b1e90e81d1f88fb11bd47ffe2e9682a.jpg";